export * from './user.service';
export * from './project.service';
export * from './devicetype.service';
export * from './userrole.service';
export * from './loopback.service';


// WEBPACK FOOTER //
// ./src/services/index.js